// extracted by mini-css-extract-plugin
export default {"summary":"MealsDescription_summary__tBtk0"};